import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSentinelChat } from './SentinelChatProvider'

/** Empty-state guide shown in the transcript before a question is asked. */
export default function Guide() {
  const { t } = useTranslation()
  const { ask } = useSentinelChat()
  const examples = t('Sentinel.V2.guide.examples', { returnObjects: true })

  return (
    <div className="px-6 py-16 mx-auto" style={{ maxWidth: '640px', textAlign: 'center' }}>
      <h2 className="fd-h2" style={{ marginBottom: '8px' }}>{t('Sentinel.V2.guide.headline')}</h2>
      <p className="fd-body" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
        {t('Sentinel.V2.guide.body')}
      </p>
      {Array.isArray(examples) && (
        <div className="grid gap-2" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', textAlign: 'left' }}>
          {examples.map((ex) => (
            <button
              key={ex}
              onClick={() => ask(ex)}
              className="fd-card fd-card--p16 fd-card--hover"
              style={{ cursor: 'pointer', fontSize: '13px', color: 'var(--text-secondary)' }}
            >
              {ex}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
